document.addEventListener("DOMContentLoaded", () => {
  const materialModal = document.getElementById("materialFormModal");
  const form = document.getElementById("materialForm");
  const saveBtn = document.getElementById("saveMaterialBtn");

  // Listen for dropdown edit clicks
  document.querySelectorAll("[data-action='edit'][href='#materialFormModal']").forEach(link => {
    link.addEventListener("click", () => {
      form.dataset.materialId = link.dataset.materialId;
      document.getElementById("material_name").value = link.dataset.materialName;
      document.getElementById("material_uom").value = link.dataset.materialUom;
    });
  });

  // Save handler
  if (saveBtn) {
    saveBtn.onclick = function () {
      const materialId = form.dataset.materialId;
      const url = materialId ? `/materials/${materialId}` : "/materials";
      const method = materialId ? "PATCH" : "POST";

      const payload = {
        name: document.getElementById("material_name").value,
        unit_of_measurement: document.getElementById("material_uom").value
      };

      fetch(url, {
        method: method,
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          "X-CSRF-Token": document.querySelector("meta[name='csrf-token']").content
        },
        body: JSON.stringify({ material: payload })
      })
        .then(response => response.json())
        .then(data => {
          if (data.success) {
            window.location.reload();
          } else {
            alert(data.errors ? data.errors.join(", ") : data.error || "Error saving material");
          }
        })
        .catch(error => {
          console.error("Error:", error);
          alert("Network error saving material");
        });
    };
  }
});
